// extracted by mini-css-extract-plugin
export default {"container":"mainHotel_container__ii1Le","mainBox":"mainHotel_mainBox__MJvKZ","flex":"mainHotel_flex__A+ZiX","content":"mainHotel_content__9ADe0"};